/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React, { useState } from "react";
import { motion } from "framer-motion";
import WhatsLayout from "../layouts/WhatsLayout";
import { useUI } from "../theme/ThemeProvider";

// استيراد المكونات الثلاثة
import EmployeesTab from "./Employees/EmployeesTab";


// Using colors from useUI instead of hardcoded COLORS

export default function AdminEmployeesPage() {
  const { theme, lang, colors } = useUI();
  const isDark = theme === "dark";
  const isArabic = lang === "ar";

  const [activeTab, setActiveTab] = useState("employees");



  return (
    <WhatsLayout title={isArabic ? "إدارة الموظفين" : "Employees Management"}>
      <section
        dir={isArabic ? "rtl" : "ltr"}
      >



        {/* ===== عرض المحتوى حسب التبويب ===== */}
        <div className="mt-8">
          {activeTab === "employees" && <EmployeesTab />}
        </div>
      </section>
    </WhatsLayout>
  );
}
